import { Navigate } from 'react-router-dom';

/**
 * /about — historical redirect to /faq.
 *
 * The Next.js version called `redirect('/faq')` from a server component, which
 * threw a sentinel error caught by Next's router. In the Vite/React Router
 * build the closest equivalent is the declarative `<Navigate>` component,
 * which short-circuits rendering and updates the URL.
 *
 * Using `<Navigate replace />` so the back button skips over /about — matches
 * what `redirect()` does on the server (no history entry for the redirector).
 */
export default function AboutPage() {
  return <Navigate to="/faq" replace />;
}
